import Vue from 'vue'
import Vue2ClickOutside from 'vue2-click-outside'

Vue.use(Vue2ClickOutside)
